let index = 0;
const $document = $(document);
const $window = $(window);
const $body = $('body');

export default class DropdownMenu {
	constructor(options = {}) {
		Object.assign(this, {
			itemSelector: '.dropdown-menu',
			toggleSelector: '.dropdown-menu__toggle', 
			popupSelector: '.dropdown-menu__popup',
			popupActiveClassname: 'dropdown-menu__popup--open',
			popupUpClassname: 'dropdown-menu__popup--up',
			popupLeftClassname: 'dropdown-menu__popup--left'			
		}, options);

		$(this.itemSelector).each((i, item) => {
			new DropdownMenuItem({
				item: item, 
				dropdownMenu: this,
			});
		});
	}
}

class DropdownMenuItem {
	constructor({
		item,
		dropdownMenu
	} = {}) {
		this.dropdownMenu = dropdownMenu;
		this.namepsace = 'dropdown-menu-item-' + (index++);
		this.$item = $(item);
		this.$toggle = this.$item.find(dropdownMenu.toggleSelector);
		this.$popup = this.$item.find(dropdownMenu.popupSelector);
		this.$context = 
			this.$item.closest('.overlay').length > 0 ?
			$('.overlay') : $body;

		this.$toggle.on('click', this.itemClickHandler.bind(this));
		this.$popup.on('open', this.popupOpenHandler.bind(this));
		this.$popup.on('close', this.popupCloseHandler.bind(this));
	}

	itemClickHandler(e) {
		e.preventDefault();

		this.$popup.trigger(
			this.$popup.hasClass(
				this.dropdownMenu.popupActiveClassname
			) ? 'close' : 'open'
		);		
	}

	popupCloseHandler(e) {
		this.$popup.removeClass(this.dropdownMenu.popupActiveClassname);
		$document.off('click.' +  this.namespace);
	}

	popupOpenHandler(e) {
		const contextScrollHeight = this.$context.prop('scrollHeight'); // Get value before menu is open, since it can change the height

		this.$popup
			.addClass(this.dropdownMenu.popupActiveClassname)
			.removeClass(this.dropdownMenu.popupLeftClassname)
			.removeClass(this.dropdownMenu.popupUpClassname)
			.css('max-height', '');

		const contextScrollTop = this.$context.scrollTop();
		const documentScrollTop = $document.scrollTop();
		const submenuWidth = this.$popup.outerWidth(true);
		const submenuHeight = this.$popup.outerHeight(true);
		const submenuOffsetLeft = this.$popup.offset().left;
		const submenuOffsetTop = this.$popup.offset().top - documentScrollTop + contextScrollTop;
		const submenuDistanceFromToggle = 4; // Sync with css
		const toggleOffsetTop = this.$toggle.offset().top - documentScrollTop + contextScrollTop;
		const toggleOffsetBottom = toggleOffsetTop + this.$toggle.outerHeight();
		const availableHeightBelowToggle = contextScrollHeight - toggleOffsetBottom - submenuDistanceFromToggle;

		if ((submenuOffsetLeft + submenuWidth) > $window.width()) {
			this.$popup.addClass(this.dropdownMenu.popupLeftClassname);
		}

		// Go up if to little space below
		if (availableHeightBelowToggle < submenuHeight && submenuHeight < contextScrollHeight) {
			this.$popup
				.addClass(this.dropdownMenu.popupUpClassname)
				.css('max-height', toggleOffsetTop - 16)
				.scrollTop(0, 0);
		} else {
			this.$popup
				.css('max-height', contextScrollHeight - submenuOffsetTop - 16)
				.scrollTop(0, 0);
		}

		setTimeout(() => {
			$document.on('click.' + this.namespace, (e) => {
				if (!$.contains(this.$popup.get(0), e.target) && !this.$popup.is(e.target)) {
					this.$popup.trigger('close');
				}
			});
		}, 0);
	}
}